var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "none-order", class: _vm.myClass }, [
    _c(
      "div",
      { staticStyle: { "text-align": "center" } },
      [
        _c("img", { attrs: { src: _vm.imgUrl } }),
        _vm._v(" "),
        _c("div", { staticClass: "no-text" }, [_vm._v(_vm._s(_vm.text))]),
        _vm._v(" "),
        _vm.showRefreshBtn
          ? _c("div", { staticClass: "refresh", on: { click: _vm.refresh } }, [
              _vm._v("重新加载"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }